import {
  formatEventDateLabel,
  resolveEventDisplayTimeZone,
  toEventListingFields,
  toEventLocationLabel,
} from './map-events-management-event'
import type { EventsHubCard } from '../types/events-hub'
import type { EventsPortalState, EventsPortalStatePage } from '../types/events-management'

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : undefined

const asString = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

export const mapPortalEvent = (value: unknown): EventsHubCard | undefined => {
  const event = asRecord(value)
  if (!event) return undefined

  const id = asString(event.id)
  const title = asString(event.eventName)
  if (!id || !title) return undefined

  const startDateTime = asString(event.startDateTime)
  const endDateTime = asString(event.endDateTime)
  const timezone = asString(event.timezone) || undefined
  const description = asString(event.summary)
  const place = asRecord(event.place)
  const displayTimeZone = resolveEventDisplayTimeZone(place, timezone)

  return {
    id,
    title,
    imageUrl: asString(event.coverImage),
    dateLabel: formatEventDateLabel(startDateTime, endDateTime, displayTimeZone),
    locationLabel: toEventLocationLabel(place),
    ...toEventListingFields(startDateTime, endDateTime, displayTimeZone),
    ...(description ? { description } : {}),
    ...(event.registered === true ? { isRegistered: true } : {}),
  }
}

export const mapPortalEventsByState = (bucket: EventsPortalStatePage, state: EventsPortalState): EventsHubCard[] =>
  bucket.events.flatMap(value => {
    const mapped = mapPortalEvent(value)
    if (!mapped) return []
    if (state === 'live') return [{ ...mapped, status: 'live', isLive: true }]
    return [mapped]
  })
